Ext.define('SA.view.TimeSeriesReportTransposedGrid', {
    alias: 'widget.time-series-report-transposed-grid',
    extend: 'SA.view.ReportGrid',

    listeners: {
        'cell:click': function(grid, td, data, column) {
            var location = data.id,
                variable = column.dataIndex;

            if (variable === 'name') {
                grid.showRowMenu(td, location);
            }
            else {
                grid.showCellMenu(td, variable, location);
            }
        },

        'cell:mouseout': function(grid, td) {
            Ext.fly(td).removeCls('sa-grid-cell-over');
        },

        'cell:mouseover': function(grid, td) {
            Ext.fly(td).addCls('sa-grid-cell-over');
        },

        'column:click': function(grid, el, column) {
            var dataIndex = column.dataIndex;

            if (dataIndex === 'name') {
                grid.showLocationsColumnMenu(el, dataIndex);
            }
            else {
                grid.showVariableColumnMenu(el, dataIndex);
            }
        },

        'column:mouseout': function(grid, td) {
            Ext.fly(td).removeCls('sa-grid-cell-over');
        },

        'column:mouseover': function(grid, td) {
            Ext.fly(td).addCls('sa-grid-cell-over');
        }
    },

    initComponent() {
        var reportModel = this.projectView;

        this.columns = this.buildColumns();
        this.data = [];

        this.callParent();

        this.refreshData();

        this.mon(reportModel, {
            buffer: 10,
            scope: this,

            'change:attribute': this.onChangeAttribute,
            'change:includeProjections': this.onChangeIncludeProjections,
            'change:filter': this.onChangeFilter,
            'change:filterVisibility': this.onChangeFilter,
            'change:location': this.onChangeLocations
        });

        this.mon(SA.data.LocationAliases, {
            buffer: 10,
            scope: this,

            'change': this.onChangeAlias
        });
    },

    buildColumns() {
        var me = this;

        return [
            {
                cellCls: 'sa-report-grid-row-header',
                dataIndex: 'name',
                encodeCells: false,
                forceRender: true,
                locked: true,
                text: 'Location',
                width: 200
            },
            ...getVariableColumns()
        ];

        function getVariableColumns() {
            var projectView = me.projectView,
                seriesAttributes = projectView.getSeriesAttributes(me.refreshColumns, me),
                attributeIds = seriesAttributes.map(({attribute}) => attribute),
                attributes = SA.data.AttributesCache.get(attributeIds, me.refreshColumns, me);

            return attributes.map((attribute, index) => {
                return {
                    align: 'right',
                    autoWidth: 215,
                    contentWidth: true,
                    dataIndex: attributeIds[index],
                    encodeText: false,
                    text: attribute && me.getHeaderHtmlForAttribute(attribute)
                };
            });
        }
    },

    getRowCls(data) {
        if (data.strikeout) {
            return 'sa-report-grid-strikeout';
        }
    },

    onChangeAlias() {
        this.refreshData();
    },

    onChangeAttribute() {
        this.refreshColumns();
        this.refreshData();
    },

    onChangeFilter() {
        this.refreshData();
    },

    onChangeIncludeProjections() {
        this.refreshColumns();
        this.refreshData();
    },

    onChangeLocations() {
        this.refreshData();
    },

    refreshColumns() {
        this.setColumns(this.buildColumns());
    },

    refreshData() {
        var oldData = this.data,
            reportModel = this.projectView,
            dataMap = reportModel.getReportData({fn: this.refreshData, scope: this}),
            seriesAttributes = reportModel.getSeriesAttributes(this.refreshData, this),
            attributeIds = seriesAttributes.map(({attribute}) => attribute),
            attributes = SA.data.AttributesCache.get(attributeIds, this.refreshData, this),
            locationIds = reportModel.getLocations(),
            locations = SA.data.LocationsCache.get(locationIds),
            rowsMap = {},
            data = [],
            filter = reportModel.getFilterQuery(),
            filterVisibility = filter && reportModel.getFilterVisibility(),
            strikeout = filterVisibility === 'strikeout',
            hide = filterVisibility === 'hide',
            isLoading = false,
            hasData = false;

        oldData.forEach(row => {
            rowsMap[row.id] = row;
        });

        locations.forEach((location, index) => {
            var locationId = locationIds[index],
                row = rowsMap[locationId],
                filtered = dataMap[locationId].filter === false;

            if (hide && filtered) {
                return;
            }

            if (!row) {
                row = {id: locationId};
            }

            row.name = Ext.util.Format.locationRenderer(location);
            row.strikeout = strikeout && filtered;

            attributes.forEach((attribute, index) => {
                var attributeId = attributeIds[index],
                    value = dataMap[locationId][attributeId],
                    format = attribute && attribute.formatString;

                if (format && typeof value !== 'undefined') {
                    value = SA.data.AttributesCache.formatValue(value, format);
                    hasData = true;
                }
                else {
                    isLoading = true;
                }

                row[attributeId] = value || '';
            });

            data.push(row);
        });

        this.isLoading = isLoading;

        this.setData(data);
        this.setLoading(isLoading && !hasData);
    },

    showCellMenu(el, attribute, location) {
        var items = [
            {
                xtype: 'menu-attribute-caption'
            }, {
                xtype: 'menu-location-caption'
            }, {
                xtype: 'menu-create-map'
            }, {
                xtype: 'menu-create-ranking'
            }
        ];

        this.showMenu(el, items, {attribute, location});
    },

    showLocationsColumnMenu(el) {
        var items = [
            {
                xtype: 'menu-attribute-caption'
            }, {
                text: 'Sort locations A-Z',
                disabled: this.isLoading,
                handler: () => this.sort('asc')
            }, {
                text: 'Sort locations Z-A',
                disabled: this.isLoading,
                handler: () => this.sort('desc')
            }
        ];

        this.showMenu(el, items, {attribute: 'name'});
    },

    showRowMenu(el, location) {
        var items = [
            {
                xtype: 'menu-location-caption'
            }, {
                xtype: 'menu-add-remove-favorite-location'
            }, {
                xtype: 'menu-set-location-alias'
            }, {
                xtype: 'menu-remove-location'
            }
        ];

        this.showMenu(el, items, {location});
    },

    showVariableColumnMenu(el, attribute) {
        var me = this,
            projectView = this.projectView,
            items = [
                {
                    xtype: 'menu-attribute-caption'
                }, {
                    xtype: 'menu-add-remove-favorite-attribute'
                }, {
                    xtype: 'menu-view-attribute-metadata'
                }, {
                    xtype: 'menu-open-data-folder'
                }, {
                    xtype: 'menu-create-bar-chart'
                }, {
                    text: 'Sort, smallest to largest',
                    disabled: this.isLoading,
                    handler: () => sort('asc')
                }, {
                    text: 'Sort, largest to smallest',
                    disabled: this.isLoading,
                    handler: () => sort('desc')
                }
            ];

        this.showMenu(el, items, {attribute});

        function sort(direction) {
            var dataMap = projectView.getReportData(),
                values = {};

            Object.entries(dataMap).forEach(([location, locationData]) => {
                values[location] = locationData[attribute];
            });

            me.sort(direction, values);
        }
    },

    sort(direction, values) {
        this.projectView.setSort(null);
        this.projectView.sortLocations(SA.data.Sort.createLocationSorter(values, direction));

        this.projectView.save();
    }
});
